import { render, staticRenderFns } from "./IndividualThankYou.vue?vue&type=template&id=30f96242&"
import script from "./IndividualThankYou.vue?vue&type=script&lang=js&"
export * from "./IndividualThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports